import self from '../img/self.png';
import mock1 from '../img/mock1.png';
import mock2 from '../img/mock2.png';
import mock3 from '../img/mock3.png';
import mock4 from '../img/mock4.png';
import mock5 from '../img/mock5.png';

export let colors = ['rgb(0,255,164)', 'rgb(166,104,255)'];

export const info = {
	firstName: 'John',
	lastName: 'Ospina',
	initials: 'john',
	selfPortrait: self,
	gradient: `-webkit-linear-gradient(135deg, ${colors})`,
	baseColor: colors[0],
	miniBio: [
		{
			emoji: '☕',
			text: 'impulsado por el café',
		},
		{
			emoji: '🌎',
			text: 'Cali - Colombia',
		},
		{
			emoji: '👨‍💻',
			text: 'Probaste googleando?',
		},
	],
	socials: [
		{
			link: 'https://github.com/ospinajohn',
			icon: 'fa fa-github',
			label: 'github',
		},
		{
			link: 'https://www.linkedin.com/in/john-james-ospina-959302212/',
			icon: 'fa fa-linkedin',
			label: 'linkedin',
		},
	],
	bio: '¡Hola! Soy John James Ospina, tengo 24 años. Soy desarrollador back-end con experiencia en proyectos full-stack, enseñé programación en Python y fui monitor en mi universidad. Actualmente estoy en mi último semestre estudiando Tecnología de Sistemas de Información y disfruto aprendiendo de otros y ofreciéndoles mis conocimientos para que puedan aprender de mí.',
	skills: {
		proficientWith: [
			'nodejs',
			'python',
			'php',
			'javascript',
			'react',
			'mysql',
			'mongodb',
		],
		exposedTo: ['aws'],
	},
	hobbies: [
		{
			label: 'leer',
			emoji: '📖',
		},
		{
			label: 'caminar',
			emoji: '🚶',
		},
		{
			label: 'peliculas o series',
			emoji: '🎥',
		},
		{
			label: 'ejercitarme',
			emoji: '💪',
		},
		{
			label: 'musica',
			emoji: '🎧',
		},
	],
	portfolio: [
		{
			title: 'App GYM didactic',
			// live: 'https://paytonpierce.dev',
			source: 'https://github.com/ospinajohn/app-gym-didactic',
			image: mock1,
		},
		{
			title: 'Giffy',
			live: 'https://giffy-search-app.vercel.app/',
			source: 'https://github.com/ospinajohn/giffy',
			image: mock2,
		},
		// {
		// 	title: 'Project 3',
		// 	live: 'https://paytonpierce.dev',
		// 	source: 'https://github.com/paytonjewell',
		// 	image: mock3,
		// },
		// {
		// 	title: 'Project 4',
		// 	live: 'https://paytonpierce.dev',
		// 	source: 'https://github.com/paytonjewell',
		// 	image: mock4,
		// },
		// {
		// 	title: 'Project 5',
		// 	live: 'https://paytonpierce.dev',
		// 	source: 'https://github.com/paytonjewell',
		// 	image: mock5,
		// },
	],
};
